import React, { useEffect, useState, useMemo,useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useOutletContext } from 'react-router';
import { useOrgList } from '../../hooks/useOrg';

import Cookies from 'js-cookie';
import { useAuthContext } from '../../context/Auth';
import useAxiosInstance from '../../api/interceptor';
import { useUserContext } from '../../context/User_Access';
import { useUserAddMutation, useUserUpdateMutation, useUserRoles } from '../../hooks/useUser';

import {
  Box,
  Typography,
  Modal,
  FormControl,
  OutlinedInput,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  AccordionDetails,
  AccordionSummary,
  Accordion
} from '@mui/material';

import ButtonSecondary from '../button/Btn_secondary';
import SklInputPopup from '../skeletons/Skl_input_popup';
import ButtonSecondaryLoader from '../button/Btn_secondary_loader';

import ModalStyle from './Modal_styles.module.scss';
import './Modal_styles.scss';

import CheckIcon from '../../assets/tick-select.svg';
import UncheckIcon from '../../assets/tick-notselect.svg';
import ArrowDownIcon from '../../assets/arrow-head-down.svg';
import CheckOrgIcon from '../../assets/singleTickIcon.svg';
import UncheckOrgIcon from '../../assets/singleUnTickIcon.svg';

const UserAddModal = ({
  openAddUser,
  setOpenAddUser,
  editId,
  editData,
  userEditLoading,
  setUserId,
  userId
}) => {
  const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm();
  const [uploading, setUploading] = useState(false);
  const [selOrg, setSelOrg] = useState([]);
  const [orgList, setOrgList] = useState([]);
  const { triggerAlert } = useOutletContext();
  const [selRole, setSelRole] = useState('');
  const { tokenReview } = useAuthContext();
  const axiosInstance = useAxiosInstance();
  const [btnLoading, setBtnLoading] = useState(false);
  const { setUserDetails } = useUserContext();
  const cookieOptions = useRef({});
  const [orgRestructure, setOrgRestructure] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [isGlobalUser, setIsGlobalUser] = useState(1);
  const { data: orgListData, isLoading: orgListLoading, isError: orgListError, isSuccess: orgListSuccess, error: orgListErrorMsg } = useOrgList();
  const { data: userRolesData, isError: userRolesError, error: userRolesErrorMsg } = useUserRoles();

  // Error handling for roles and orgs:
  useEffect(() => {
    if (!userRolesError) return;
    const errorMessage = userRolesErrorMsg?.response?.data?.error?.text || 
      'The server encountered an error and could not complete your request.';
    triggerAlert('fail', errorMessage);
  }, [userRolesError]);

  useEffect(() => {
    if (!orgListError) return;
    const errorMessage = orgListErrorMsg?.response?.data?.error?.text || 
      'The server encountered an error and could not complete your request.';
    triggerAlert('fail', errorMessage);
  }, [orgListError]);

  // Process organization data and assign types.
  useEffect(() => {
    if (!orgListData?.organizations) return;
    const newOrgArray = newSearchField(orgListData.organizations);
    newOrgStructure(orgListData.organizations);
    setOrgList(newOrgArray);
  }, [orgListSuccess, orgListData?.organizations]);

  // Set edit user data and pre-select parent for sub organizations.
  useEffect(() => {
    setValue('email', editData?.email);
    setValue('name', editData?.name);
    setSelRole(editData?.role?.id);
    if (editData?.orgIds) {
      let newOrgIds = [...editData.orgIds];
      // editData.orgIds.forEach(id => {
      //   const org = findOrgById(id);
      //   if (org && org.type === 'subOrg' && org.parentOrgId && !newOrgIds.includes(org.parentOrgId)) {
      //     newOrgIds.push(org.parentOrgId);
      //   }
      // });
      console.log('newOrgIds > ', newOrgIds, editData)
      setSelOrg(newOrgIds);
    }
  }, [editData, userId]);

  // Set cookie options.
  useEffect(() => {
    const domain = window.location.hostname;
    const isSecure = domain === 'localhost' ? false : 
      domain.includes('invoiceai.local') ? false : true;
      cookieOptions.current = {
        path: '/',
        secure: isSecure, 
        sameSite: 'lax',
        expires: 30,
    };
  }, []);

  //check user access

  useEffect(()=>{
    const selUserObj = userRolesData?.userRoles?.filter(item => item.id == selRole)
    setIsGlobalUser( selUserObj?.at(0)?.globalAccess)
  },[selRole])

  const cancel = () => {
    setOpenAddUser(false);
    reset({ email: '', name: '', password: '', role: '' });
    setSelRole('');
    setUserId(0);
    setSelOrg([]);
  };

  useEffect(() => {
    setValue('role', selRole);
  }, [selRole]);

  const onSubmit = (data) => {
    const newData = { ...data, orgIds: selOrg };
    setUploading(true);
    setBtnLoading(true);
    if (editId === 0) {
      dataPost(newData);
    } else {
      dataUpdate(newData);
    }
  };

  const handleSuccessAddUser = (data) => {
    triggerAlert('success', data.message);
    setOpenAddUser(false);
    reset({ email: '', name: '', password: '', role: '' });
    setSelRole('');
    setUploading(false);
    setBtnLoading(false);
    setUserId(0);
    setSelOrg([]);
  };

  const { mutate: dataPost, isError: mCreateUserIsError, error: mCreateUserError } = useUserAddMutation(handleSuccessAddUser);

  useEffect(() => {
    if (!mCreateUserIsError) return;
    const errorMessage = mCreateUserError?.response?.data?.error?.text || 
      'The server encountered an error and could not complete your request.';
    triggerAlert('fail', errorMessage);
    setBtnLoading(false);
    setUploading(false);
  }, [mCreateUserIsError]);

  const handleSuccessUpdateUser = (data) => {
    triggerAlert('success', data.message);
    setOpenAddUser(false);
    reset({ email: '', name: '', password: '', role: '' });
    setSelRole('');
    setUploading(false);
    setBtnLoading(false);
    if (data.updatedPermissions) {
      setUserDetails(data.updatedName, undefined, undefined, undefined, undefined, undefined);
      Cookies.set('userName', data.updatedName, cookieOptions.current);
    }
    setUserId(0);
    setSelOrg([]);
  };

  const { mutate: dataUpdate, isError: mUpdateUserIsError, error: mUpdateUserError } = useUserUpdateMutation(userId, handleSuccessUpdateUser);

  useEffect(() => {
    if (!mUpdateUserIsError) return;
    const errorMessage = mUpdateUserError?.response?.data?.error?.text || 
      'The server encountered an error and could not complete your request.';
    triggerAlert('fail', errorMessage);
    setBtnLoading(false);
    setUploading(false);
  }, [mUpdateUserIsError]);

  useEffect(() => {
    console.log('selOrg', selOrg);
  }, [selOrg]);

  // Helper: Find an organization by its id (main or sub)
  const findOrgById = (id) => {
    let org = orgList.find(o => o.id === id);
    if (org) return org;
    for (let main of orgList) {
      if (main.subOrganisations) {
        const sub = main.subOrganisations.find(s => s.id === id);
        if (sub) return sub;
      }
    }
    return null;
  };

  // handleOrgClick: Toggle selection with exclusive rules.
  const handleOrgClick = (orgId) => {
    const clickedOrg = findOrgById(orgId);
    if (!clickedOrg) return;

    if (clickedOrg.type === 'mainOrg') {
      // If parent is clicked: toggle selection.
      if (selOrg.includes(orgId)) {
        setSelOrg([]);
      } else {
        setSelOrg([orgId]);
      }
    } else {
      // For sub organizations:
      const parentId = clickedOrg.parentOrgId;
      // Check if any parent is selected.
      const hasParentSelected = selOrg.some(id => {
        const org = findOrgById(id);
        return org && org.type === 'mainOrg';
      });
      // Determine current sub org group (if any)
      const currentSubGroup = selOrg.filter(id => {
        const org = findOrgById(id);
        return org && org.type === 'subOrg';
      });
      let currentGroupParent = null;
      if (currentSubGroup.length > 0) {
        const firstSub = findOrgById(currentSubGroup[0]);
        currentGroupParent = firstSub ? firstSub.parentOrgId : null;
      }
      if (hasParentSelected || (currentGroupParent && currentGroupParent !== parentId)) {
        // Clear previous selection and select only the clicked sub org.
        setSelOrg([orgId]);
      } else {
        // Toggle the sub organization.
        if (selOrg.includes(orgId)) {
          setSelOrg(selOrg.filter(id => id !== orgId));
        } else {
          setSelOrg([...selOrg, orgId]);
        }
      }
    }
  };

  // Determine active parent organization (for styling).
  const activeParent = useMemo(() => {
    if (selOrg && selOrg.length > 0) {
      const selectedMain = selOrg.find(id => {
        const org = findOrgById(id);
        return org && org.type === 'mainOrg';
      });
      if (selectedMain) return selectedMain;
      const selectedSub = selOrg.find(id => {
        const org = findOrgById(id);
        return org && org.type === 'subOrg';
      });
      if (selectedSub) {
        const org = findOrgById(selectedSub);
        return org ? org.parentOrgId : null;
      }
    }
    return null;
  }, [selOrg, orgList]);

  // Process organization data: add a "type" property to main orgs and sub orgs.
  const newSearchField = (orgs) => {
    return orgs.map(org => ({
      ...org,
      type: 'mainOrg',
      subOrganisations: org.subOrganisations.map(sub => ({
        ...sub,
        type: 'subOrg',
        parentOrgId: org.id,
      }))
    }));
  };

  const newOrgStructure = (orgs) => {
    const transformedArray = orgs.reduce((acc, org) => {
      acc[org.id] = org.subOrganisations.map(sub => sub.id);
      return acc;
    }, {});
    setOrgRestructure(transformedArray);
  };

  return (
    <div>
      <Modal open={openAddUser} aria-labelledby="modal-modal-title">
        <Box className={`${ModalStyle['modal-base']} ${ModalStyle['modal-secret-key']}`}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={ModalStyle['modal-container']}>
              <div className={ModalStyle['content-wrapper']}>
                <Typography id="modal-modal-title" align="center" className={ModalStyle['modal-Header1']} variant="text24" component="h2">
                  {editId === 0 ? 'Add new user' : 'Edit user'}
                </Typography>
                <FormControl variant="standard" fullWidth margin="normal" className="modal-mt-12 form-control">
                  <InputLabel shrink htmlFor="name" className="modal-label">
                    Name
                  </InputLabel>
                  {userEditLoading ? (
                    <SklInputPopup />
                  ) : (
                    <>
                      <OutlinedInput
                        id="name"
                        placeholder="Enter name"
                        autoComplete="off"
                        type="text"
                        className="modal-input"
                        {...register('name', { required: true })}
                      />
                      {errors.name && <p className="err-msg">Name is required</p>}
                    </>
                  )}
                </FormControl>
                <FormControl variant="standard" fullWidth margin="normal" className="form-control">
                  <InputLabel shrink htmlFor="email" className="modal-label">
                    Email
                  </InputLabel>
                  {userEditLoading ? (
                    <SklInputPopup />
                  ) : (
                    <>
                      <OutlinedInput
                        id="email"
                        placeholder="Enter email address"
                        autoComplete="off"
                        type="text"
                        className="modal-input"
                        {...register('email', {
                          required: true,
                          pattern: {
                            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                          }
                        })}
                        disabled={editId === 0 ? false : true}
                      />
                      {errors.email && errors.email.type === 'required' && <p className="err-msg">Email is required</p>}
                      {errors.email && errors.email.type === 'pattern' && <p className="err-msg">Invalid email address</p>}
                    </>
                  )}
                </FormControl>
                <FormControl variant="standard" fullWidth margin="normal" className={`form-control ${isGlobalUser !== 0 ? 'modal-mb-10':''}`}>
                  <InputLabel shrink htmlFor="role" className="modal-label">
                    Role
                  </InputLabel>
                  {userEditLoading ? (
                    <SklInputPopup />
                  ) : (
                    <>
                      <Select
                        id="role"
                        className="w-modal-full select-modal type-filter-select"
                        input={<OutlinedInput />}
                        displayEmpty
                        value={selRole || ''}
                        renderValue={(value) => {
                          if (!value) {
                            return <span className="text-sonicSilver">-Select user role-</span>;
                          }
                          const role = userRolesData?.userRoles?.find(role => role.id == value);
                          return role ? role.name : '';
                        }}
                        inputProps={{ 'aria-label': 'Role' }}
                        {...register('role', { required: editId === 0 ? true : false, onChange: (e) => setSelRole(e.target.value) })}
                      >
                        {userRolesData?.userRoles?.map((role, index) => (
                          <MenuItem key={index} value={role.id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {errors.role && <p className="err-msg">Role is required</p>}
                    </>
                  )}
                </FormControl>
                { isGlobalUser === 0  ? (
                    <FormControl variant="standard" fullWidth margin="normal" className="form-control modal-mb-10">
                    <InputLabel shrink htmlFor="orgIds" className="modal-label">
                        Organization
                    </InputLabel>
                    {userEditLoading ? (
                        <SklInputPopup />
                    ) : (
                        <>
                        <Controller
                            name="orgIds"
                            control={control}
                            defaultValue={[]}
                            rules={{ validate: (value) => selOrg.length > 0 || 'Organization is required' }}
                            render={({ field, fieldState: { error } }) => (
                            <>
                                <Select
                                {...field}
                                id="orgIds"
                                className="w-modal-full select-modal type-filter-select"
                                multiple
                                value={selOrg}
                                input={<OutlinedInput />}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected || selected.length === 0) {
                                    return <span className="text-sonicSilver">-Select organization-</span>;
                                    } else {
                                    // If a parent org is selected, display its name.
                                    const firstOrg = findOrgById(selected[0]);
                                    if (firstOrg && firstOrg.type === 'mainOrg') {
                                        return firstOrg.orgName;
                                    } else {
                                        // Otherwise, list names of selected sub organizations.
                                        const names = selected.map(id => {
                                        const o = findOrgById(id);
                                        return o ? o.orgName : '';
                                        });
                                        return names.join(', ');
                                    }
                                    }
                                }}
                                inputProps={{ 'aria-label': 'organization' }}
                                >
                                {orgList.map((filter) => (
                                    <Accordion key={filter.id} expanded={expanded === filter.id} className="shadow-none m-0 border-x-0 border-y-cultured">
                                    <AccordionSummary
                                        aria-controls="panel1d-content"
                                        id="panel1d-header"
                                        className="m-0 pl-0 hover:bg-[#f5f5f5]"
                                        onClick={(e) => e.stopPropagation()}
                                        expandIcon={
                                        <span
                                            onClick={(e) => {
                                            e.stopPropagation();
                                            setExpanded(expanded === filter.id ? false : filter.id);
                                            }}
                                        >
                                            <img
                                            src={ArrowDownIcon}
                                            alt="arrow down"
                                            className={`${filter.subOrganisations.length > 0 ? '' : 'opacity-20'} w-5`}
                                            />
                                        </span>
                                        }
                                    >
                                        <MenuItem
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleOrgClick(filter.id);
                                        }}
                                        className={`country-down-item mt-0 w-full !mx-2 org-specific item-multi mainOrg rounded-none hover:bg-transparent ${filter.parentOrgId !== null && activeParent && filter.parentOrgId !== activeParent ? 'non-select' : ''}`}
                                        value={filter.id}
                                        >
                                        <Checkbox
                                            checked={selOrg.includes(filter.id)}
                                            checkedIcon={<img src={CheckOrgIcon} alt="checked" className="w-6" />}
                                            icon={<img src={UncheckOrgIcon} alt="uncheck" className="w-6" />}
                                        />
                                        {filter.orgName}
                                        </MenuItem>
                                    </AccordionSummary>
                                    {filter.subOrganisations.map((subOrgItem) => (
                                        <AccordionDetails
                                        key={subOrgItem.id}
                                        className="p-0"
                                        onClick={(e) => e.stopPropagation()}
                                        >
                                        <MenuItem
                                            onClick={(e) => {
                                            e.stopPropagation();
                                            handleOrgClick(subOrgItem.id);
                                            }}
                                            className={`country-down-item org-specific item-multi my-0 hover:bg-cultured rounded-none subOrg ${filter.parentOrgId !== null && activeParent && filter.parentOrgId !== activeParent ? 'non-select' : ''}`}
                                            value={subOrgItem.id}
                                        >
                                            <Checkbox
                                            checked={selOrg.includes(subOrgItem.id)}
                                            checkedIcon={<img src={CheckIcon} alt="checked" className="w-6" />}
                                            icon={<img src={UncheckIcon} alt="uncheck" className="w-6" />}
                                            />
                                            {subOrgItem.orgName}
                                        </MenuItem>
                                        </AccordionDetails>
                                    ))}
                                    </Accordion>
                                ))}
                                </Select>
                                {error && <span className="err-msg">{error.message}</span>}
                            </>
                            )}
                        />
                        </>
                    )}
                    </FormControl>
                ) : null}
              </div>
              <div className={ModalStyle['footer-wrapper-center']}>
                <ButtonSecondary btnName="Cancel" variant={'primaryBtn'} classes="modal-button-12" type="button" onClick={cancel} disabled={uploading} />
                <ButtonSecondaryLoader variant={'secondaryBtn'} type="submit" classes="modal-button-12" btnName={editId === 0 ? "Add" : 'Save'} btnLoading={btnLoading} disabled={false} />
              </div>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default UserAddModal;
